import React from 'react';

// Row of theme filter chips for the News page.
const ThemeFilter = ({ themes, active, onChange }) => (
  <div className="flex flex-wrap gap-2.5">
    {themes.map((t) => (
      <button
        key={t}
        onClick={() => onChange(t)}
        className={`px-4 py-2 rounded-full text-[13px] font-medium transition-colors border ${active === t ? 'bg-[#e8743b] text-white border-[#e8743b]' : 'text-[#cdd2dc] border-white/12 hover:border-[#e8743b]/50 hover:text-white'}`}
      >
        {t}
      </button>
    ))}
  </div>
);

export default ThemeFilter;
